import React, { useEffect } from "react";
import Layout from "../../components/Layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaClipboardList, FaUserSlash } from "react-icons/fa6";
import { FaPrayingHands, FaUsers, FaUsersCog } from "react-icons/fa";
import { RiAdminFill } from "react-icons/ri";
import { BiSolidReport } from "react-icons/bi";

export default function ManagePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { dataId } = location?.state || {};

  useEffect(() => {
    const refreshToken = localStorage.getItem("refreshToken");
    const roles = localStorage.getItem("roles");
    if (!refreshToken || roles !== "SuperAdmin") {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    if (!localStorage.getItem("alertShown")) {
      toast.success("Login successfully");
      localStorage.setItem("alertShown", "true");
    }
  }, []);

  return (
    <Layout ac1="active" dataId={dataId}>
      {/* Content Header (Page header) */}
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4 className="m-0 text-dark">Dashboard</h4>
            </div>
          </div>
        </div>
      </div>
      <section className="content mb-4">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/manage-admin" className="text-dark ">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-primary elevation-1">
                    <RiAdminFill />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Manage Admin</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/manage-mandal" className="text-dark ">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-warning elevation-1">
                    <FaUsers />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Manage Mandal</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/manage-group" className="text-dark ">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-dark elevation-1">
                    <FaUsersCog />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Manage Group</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/register" className="text-dark ">
                <div className="info-box mb-3">
                  <span className="info-box-icon bg-info elevation-1">
                    <FaPrayingHands />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">
                      Register Haribhakt
                    </span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/sabha-report" className="text-dark ">
                <div className="info-box mb-3" style={{ cursor: "pointer" }}>
                  <span className="info-box-icon bg-secondary elevation-1">
                    <BiSolidReport />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">Sabha Report</span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/parasabha-report" className="text-dark ">
                <div className="info-box mb-3" style={{ cursor: "pointer" }}>
                  <span className="info-box-icon bg-success elevation-1">
                    <FaClipboardList />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">
                      Para Sabha Report
                    </span>
                  </div>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <Link to="/deleted-haribhakt" className="text-dark ">
                <div className="info-box mb-3" style={{ cursor: "pointer" }}>
                  <span className="info-box-icon bg-danger elevation-1">
                    <FaUserSlash />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text pb-1 ">
                      Deleted Haribhakt
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </Layout>
  );
}
